export const normalizeCountry = (rawCountry) => {
    const normalized = {
      // English / Local variants
      Italia: "Italy",
      italia: "Italy",
      Svizzera: "Switzerland",
      Lussemburgo: "Luxembourg",
      "Paesi Bassi": "Netherlands",
      Nederland: "Netherlands",
      Giappone: "Japan",
      Australia: "Australia",
      "Melbourne, Australia": "Australia",
      Messico: "Mexico",
      "Costa Rica": "Costa Rica",
      "Regno Unito": "United Kingdom",
      "Inghilterra": "United Kingdom",
      UK: "United Kingdom",
      Singapore: "Singapore",
      Malesia: "Malaysia",
      "Stati Uniti": "United States of America",
      "United States": "United States of America",
      Spagna: "Spain",
      Deutschland: "Germany",
     
      
      // Add more as needed
    };
  
    return normalized[rawCountry?.trim()] || rawCountry?.trim();
  };
  